import * as Sentry from '@sentry/vue'

interface IReportScriptLoadErrorOptions {
  error: unknown
  integration: string
  message: string
  scriptSrc: string
}

export function reportScriptLoadError({ error, integration, message, scriptSrc }: IReportScriptLoadErrorOptions) {
  const errorType = error instanceof Event ? error.type : typeof error

  try {
    Sentry.addBreadcrumb({
      category: 'external-script',
      message,
      level: 'warning',
      data: {
        integration,
        scriptSrc,
        errorType
      }
    })
  } catch (captureError) {
    console.warn(`Failed to add ${integration} script load breadcrumb in Sentry`, captureError)
  }

  console.warn(`${message}: ${scriptSrc}`, { errorType })
}
